module.exports = __webpack_public_path__ + "images/cluster.bb348394701f2a53b5f0dc5fb0349434.png";